import { render, staticRenderFns } from "./my_win.vue?vue&type=template&id=a87cd618&scoped=true"
import script from "./my_win.vue?vue&type=script&lang=js"
export * from "./my_win.vue?vue&type=script&lang=js"
import style0 from "./my_win.vue?vue&type=style&index=0&id=a87cd618&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87cd618",
  null
  
)

export default component.exports